import { InputField } from "components/InputField";
import { TextareaField } from "components/TextareaField";
import { getCurrency } from "helper/numberFormat";
import React from "react";

const BillingTypesBody = ({ type, formik }) => {
  const currency = getCurrency();
  const exceptThisSymbols = ["e", "E", "+", "-"];

  const preventArrows = (e) => {
    if (e.which === 38 || e.which === 40 || exceptThisSymbols.includes(e.key))
      e.preventDefault();
  };
  const regex = /([0-9]*[\.|\,]{0,1}[0-9]{0,2})/s;

  return (
    <div>
      <div className="input-fields ">
        <div className="col-sm-4 billing-amount-details mt-5 ml-5">
          <div className="position-relative disabled-action billing-input-field ">
            <InputField
              type="number"
              {...{
                formik,
                title: "Bulk Billing Amount",
                name: `batch_billing_amount`,
                placeholder: "99.00",
              }}
              value={formik.values?.batch_billing_amount}
              style={{
                border: "1px solid #B5B5C3",
                backgroundColor: "#e7e7eb",
              }}
              handleChange={(e) => {
                formik.setFieldValue(
                  `batch_billing_amount`,
                  e.target.value.match(regex)[0]
                );
              }}
              onKeyDown={(e) => preventArrows(e)}
            />
            <span>
              {currency}
            </span>
          </div>
        </div>
        <div className="col-sm-9 ml-5 disabled-action text-area-field mb-10 ">
          <TextareaField
            {...{
              formik,
              title: "Statement Message",
              name: "statement_message",
              placeholder: "1st year membership",
              value: formik.values?.statement_message,

              style: {
                border: "1px solid #B5B5C3",
                resize: "none",
                backgroundColor: "#e7e7eb",
              },
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default BillingTypesBody;
